module.exports = __webpack_public_path__ + "img/l_s8.b585c04a.png";